import { Divider, Flex, Grid, Icon, Textarea, VStack } from '@chakra-ui/react';
import { LuPlus } from 'react-icons/lu';

import { Button, Card, Heading, Input, Text } from '@/components/v4';

export default function LinksTab({
    darkMode,
    linksData,
    setLinksData,
    availableFields,
    addToken,
}) {
    return (
        <Card
            bg={darkMode ? 'dark.tcap' : null}
            borderRadius="8px"
            boxShadow="0px 1px 3px rgba(0, 0, 0, 0.1)"
            p={8}
            shadow="sm"
            transition="all 0.3s">
            <VStack spacing={10} align="stretch">
                <Heading size="sm" fontWeight="semibold">
                    Links Configuration
                </Heading>
                <Grid
                    templateColumns={{
                        base: '1fr',
                        md: '1fr 3fr',
                    }}
                    gap={6}
                    alignItems="flex-start">
                    <Text fontSize="sm" fontWeight="bold">
                        Support Link
                    </Text>
                    <Textarea
                        name="supportLink"
                        h="28"
                        p={4}
                        fontSize="sm"
                        fontFamily="mono"
                        borderColor={darkMode ? 'dark.tcap-borderGray' : null}
                        bg={darkMode ? 'dark.bgDark' : null}
                        _focus={{
                            borderColor: 'messenger.500',
                            boxShadow: '0 0 0 1px #007BFF',
                        }}
                        value={linksData.extLinkSupport}
                        onChange={(e) =>
                            setLinksData((p) => ({
                                ...p,
                                extLinkSupport: e.target.value,
                            }))
                        }
                        placeholder="Support URL with tokens..."
                    />
                </Grid>
                <Grid
                    templateColumns={{
                        base: '1fr',
                        md: '1fr 3fr',
                    }}
                    gap={6}>
                    <Text fontSize="sm" fontWeight="bold">
                        Support Link Fields
                    </Text>
                    <Flex
                        wrap="wrap"
                        gap={2}
                        bg={darkMode ? 'dark.bgDark' : 'gray.50'}
                        border="1px solid"
                        borderColor={
                            darkMode ? 'dark.tcap-borderGray' : 'gray.100'
                        }
                        _hover={{
                            borderColor: darkMode
                                ? 'dark.tcap-borderGray'
                                : 'gray.200',
                        }}
                        p={4}
                        borderRadius="lg"
                        shadow="inner">
                        {availableFields.map((field) => (
                            <Button
                                key={field.value}
                                size="xs"
                                variant="outline"
                                bg="white"
                                borderRadius="full"
                                onClick={() => addToken(field.value)}
                                rightIcon={
                                    <Icon
                                        as={LuPlus}
                                        boxSize={3}
                                        color="gray.300"
                                    />
                                }
                                _hover={{
                                    borderColor: 'blue.400',
                                    bg: 'blue.50',
                                    '.chakra-button__icon': {
                                        color: 'blue.500',
                                    },
                                }}
                                fontSize="11px"
                                fontWeight="bold"
                                color="gray.600">
                                {field.label}
                            </Button>
                        ))}
                    </Flex>
                </Grid>
                <Divider />
                <VStack spacing={6} align="stretch">
                    <Grid
                        templateColumns={{
                            base: '1fr',
                            md: '1fr 3fr',
                        }}
                        gap={6}
                        alignItems="center">
                        <Text fontSize="sm" fontWeight="bold">
                            Terms of Use
                        </Text>
                        <Input
                            value={linksData.extLinkRegistrationTerms}
                            onChange={(e) =>
                                setLinksData((p) => ({
                                    ...p,
                                    extLinkRegistrationTerms: e.target.value,
                                }))
                            }
                            fontSize="sm"
                        />
                    </Grid>
                    <Grid
                        templateColumns={{
                            base: '1fr',
                            md: '1fr 3fr',
                        }}
                        gap={6}
                        alignItems="center">
                        <Text fontSize="sm" fontWeight="bold">
                            Privacy Policy
                        </Text>
                        <Input
                            value={linksData.extLinkPrivacyPolicy}
                            onChange={(e) =>
                                setLinksData((p) => ({
                                    ...p,
                                    extLinkPrivacyPolicy: e.target.value,
                                }))
                            }
                            fontSize="sm"
                        />
                    </Grid>
                </VStack>
            </VStack>
        </Card>
    );
}
